import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|System Activity|Email History|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.CandidateAccess,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateSystemActivityEmailHistory';
export type SPCandidateSystemActivityEmailHistoryLocNames =
	| `${LocNameStart}TitleSection`
	| `${LocNameStart}TitlePage`
	| `${LocNameStart}ContentDefaultType`
	| `${LocNameStart}LabelSent`
	| `${LocNameStart}LabelType`
	| `${LocNameStart}LabelContext`
	| `${LocNameStart}LabelStatus`
	| `${LocNameStart}LabelResent`
	| `${LocNameStart}LabelFilterByType`
	| `${LocNameStart}LabelEmailCatalogLink`
	| `${LocNameStart}ButtonViewEmailCatalog`
	| `${LocNameStart}ButtonViewEmail`
	| `${LocNameStart}ButtonResend`;

export const spCandidateSystemActivityEmailHistoryLocs: LocDefs<SPCandidateSystemActivityEmailHistoryLocNames> =
	{
		SPCandidateSystemActivityEmailHistoryTitleSection: {
			defaultValue: 'Candidate Email History',
			description: 'Section Title',
			displayPath: `${pathStart}Section Title`,
			displayType: 'Title',
			legacyName: 'CandidateAccess/Candidates.EmailHistory.Title.SectionTitle',
			...sharedProperties,
		},
		SPCandidateSystemActivityEmailHistoryTitlePage: {
			defaultValue: 'Candidate Email History',
			description: 'Page Title',
			displayPath: `${pathStart}Page Title`,
			displayType: 'Title',
			legacyName: 'CandidateAccess/Candidates.EmailHistory.Title.PageTitle',
			...sharedProperties,
		},
		SPCandidateSystemActivityEmailHistoryContentDefaultType: {
			defaultValue: 'System',
			description: 'Default Email Type for Content Display',
			displayPath: `${pathStart}System`,
			displayType: 'Content',
			legacyName: 'CandidateAccess/Candidates.EmailHistory.Content.DefaultType',
			...sharedProperties,
		},
		SPCandidateSystemActivityEmailHistoryLabelSent: {
			defaultValue: 'Sent',
			description: 'Column heading for: Sent.',
			displayPath: `${pathStart}Sent`,
			displayType: 'Label',
			legacyName: 'CandidateAccess/Candidates.EmailHistory.ColumnHeading.Sent',
			...sharedProperties,
		},
		SPCandidateSystemActivityEmailHistoryLabelType: {
			defaultValue: 'Type',
			description: 'Column heading for: Type.',
			displayPath: `${pathStart}Type`,
			displayType: 'Label',
			legacyName: 'CandidateAccess/Candidates.EmailHistory.ColumnHeading.Type',
			...sharedProperties,
		},
		SPCandidateSystemActivityEmailHistoryLabelContext: {
			defaultValue: 'Context',
			description: 'Column heading for: Context.',
			displayPath: `${pathStart}Context`,
			displayType: 'Label',
			legacyName: 'CandidateAccess/Candidates.EmailHistory.ColumnHeading.Context',
			...sharedProperties,
		},
		SPCandidateSystemActivityEmailHistoryLabelStatus: {
			defaultValue: 'Status',
			description: 'Column heading for: Status.',
			displayPath: `${pathStart}Status`,
			displayType: 'Label',
			legacyName: 'CandidateAccess/Candidates.EmailHistory.ColumnHeading.Status',
			...sharedProperties,
		},
		SPCandidateSystemActivityEmailHistoryLabelResent: {
			defaultValue: 'Resent',
			description: 'Column heading for: Resent.',
			displayPath: `${pathStart}Resent`,
			displayType: 'Label',
			legacyName: 'CandidateAccess/Candidates.EmailHistory.ColumnHeading.Resent',
			...sharedProperties,
		},
		SPCandidateSystemActivityEmailHistoryLabelFilterByType: {
			defaultValue: 'Filter by Type',
			description: 'Label for: Filter by Type.',
			displayPath: `${pathStart}Filter by Type`,
			displayType: 'Label',
			legacyName: 'CandidateAccess/Candidates.EmailHistory.FieldLabel.TypeFilter',
			...sharedProperties,
		},
		SPCandidateSystemActivityEmailHistoryLabelEmailCatalogLink: {
			defaultValue: 'Email Catalog',
			description: 'Column heading for: Email Catalog.',
			displayPath: `${pathStart}Email Catalog`,
			displayType: 'Label',
			legacyName: 'CandidateAccess/Candidates.EmailHistory.ColumnHeading.EmailCatalog',
			...sharedProperties,
		},
		SPCandidateSystemActivityEmailHistoryButtonViewEmailCatalog: {
			defaultValue: 'View',
			description: 'Link to view the email catalog for the email sent.',
			displayPath: `${pathStart}View Email Catalog`,
			displayType: 'Button',
			legacyName: 'CandidateAccess/Candidates.EmailHistory.Content.View',
			...sharedProperties,
		},
		SPCandidateSystemActivityEmailHistoryButtonViewEmail: {
			defaultValue: 'View',
			description: 'Button to view the email.',
			displayPath: `${pathStart}View Email`,
			displayType: 'Button',
			legacyName: 'CandidateAccess/Candidates.EmailHistory.Button.View',
			...sharedProperties,
		},
		SPCandidateSystemActivityEmailHistoryButtonResend: {
			defaultValue: 'Resend',
			description: 'Button to resend the email.',
			displayPath: `${pathStart}Resend Email`,
			displayType: 'Button',
			legacyName: 'CandidateAccess/Candidates.EmailHistory.Button.Resend',
			...sharedProperties,
		},
	};

export type SPCandidateSystemActivityEmailHistoryLocType =
	LocMap<SPCandidateSystemActivityEmailHistoryLocNames>;
